import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Footer, FooterContent } from '../_model/footer';
import { GuidedHelp } from '../_model/guidedhelp';
import { HelpTopics } from '../_model/helptopics';
import { HomeService } from '../_services/home.service';
import { AuthenticationService } from '../_services/index';
import { GoogleAnalyticsService } from '../_services/google-analytics.service';

@Component({
selector: 'app-browse',
templateUrl: './browse.component.html',
styleUrls: ['./browse.component.scss']
})
export class BrowseComponent implements OnInit {
pk: number;
topics: HelpTopics;
helpTopics: GuidedHelp = {};
name: any;
names: any;
searchdata: any[];
selectedValue: any;
keyword = 'name';
data = [];
caseAlertMessage: string;
alert: boolean = false;
delayed: boolean = false;
searchBanner: any;
searchTextboxNote: any;
searchTextboxHover: any;
searchButtonHover: any;
searchKey: any;

constructor(private activatedRoute: ActivatedRoute,
            private homeService: HomeService,
            private authenticationService: AuthenticationService,
            private router: Router,
            private gaService : GoogleAnalyticsService) {
  }

ngOnInit() {
  this.gaService.updatePageName();
  this.kbSearchConfig();
  this.getHelpTopics();
  this.caseMessage();
}


kbSearchConfig(){
  this.homeService.getKbSearchConfiguration().subscribe(res => {
    this.searchBanner = res.return_body.searchBanner;
    this.searchTextboxNote = res.return_body.searchTextboxNote;
    this.searchTextboxHover = res.return_body.searchTextboxHoverNote;
    this.searchButtonHover = res.return_body.searchButtonHoverNote;
  });
}

handleNavigation(pathValue) {
  if(pathValue){
      this.router.navigate([this.router.url.split("/")[1],pathValue]);  
  }
}
navigate(pk) {
  this.router.navigate(['/' + this.router.url.split('/')[1] + '/helptopics'], { queryParams: { PK: pk }});
}
getHelpTopics() {
  this.homeService.getHelpTopics().subscribe(res => {
    this.names= res.return_body;
    this.helpTopics = res;
    this.name=res.return_body.stepName
  });
}

selectEvent(item) {
  this.selectedValue = item.name;
  this.search(this.selectedValue);
}

onChangeSearch(val: string) {
  this.selectedValue = val;
  this.data = [];
  if (val != '') {
    this.homeService.getSearchData(val).subscribe(res => {
      this.data = [];
      res.return_body.map((response, index) => {
        this.data.push({ id: index, name: response });
      })
    });
  }
}

onFocused(e) {
  this.data = [];
}

search(selectedValue){
  this.router.navigate(['/' + this.router.url.split('/')[1] + '/searchresults'], { queryParams: { selectedValue: selectedValue, currentPage: 0 }});
}
onKeyEnterSearch(event: any, searchkeyWrd: any) {
  this.search(searchkeyWrd);
}

searchCleared(){
  this.selectedValue = '';
}

// ngAfterViewInit() {
//   this.caseMessage();
// }

 caseMessage() {
  this.caseAlertMessage = sessionStorage.getItem('alertMessage')
  if (this.caseAlertMessage) {
    this.alert = true
  }
  setInterval(() => {
    this.delayed = true
    this.alert = false
    sessionStorage.removeItem('alertMessage')
  }, 5000);
}  

}
